import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios"

import { PropertyImageData, ResponseData } from "./common"

interface PropertyImagesRequestData {
  propertyId: string | number
}

export interface PropertyImagesRequest extends Partial<AxiosRequestConfig> {
  params: PropertyImagesRequestData
}

export interface PropertyImagesResponseData extends ResponseData {
  data: PropertyImageData[]
}

export interface PropertyImagesResponse extends AxiosResponse {
  data: PropertyImagesResponseData
}

export function getPropertyImages(
  { params, method = "get", ...config }: PropertyImagesRequest,
  axiosInstance: AxiosInstance,
) {
  return axiosInstance({
    method,
    url: `/property/images/${params.propertyId}`,
    ...config,
  }) as Promise<PropertyImagesResponse>
}
